import useBens from './useBens'
import BemCard from './BemCard'
import styles from './styles.module.css'
import { useParams } from 'react-router-dom'
import { findIdealCredit } from './utils'
import LoadingBox from '../LoadingBox'
import Box from "../../../components/Box"
import Button from "../../../components/Button"
import { useState } from 'react'
import { FiArrowLeft, FiArrowRight } from 'react-icons/fi'

function Bens ({ dataManager, onNext, onBack, bens }) {
  const { segmento } = useParams()
  const { data, setData } = dataManager
  const { bensAPI, isLoading } = useBens(segmento)
  const [selectedBem, setSelectedBem] = useState(null)
  
  const handleActiveCard = (bem) => {
    setSelectedBem(selectedBem => selectedBem?.nome === bem.nome ? null : bem);
  }; 

  async function handleSubmit() {
    const {idealCredit, multNumber} = findIdealCredit(selectedBem.valor, bensAPI)
    await setData({ ...data, selectedBem, credito: idealCredit, multiple: multNumber })
    onNext()
  }

  if(isLoading){
    return <LoadingBox />
  }

  return (
    <Box className={styles.bemBox}>
      <h3>Valor do consórcio</h3>
        <h4>
          Selecione o bem que será utilizado como referência para o cálculo do
          consórcio.
        </h4>
        <ul className={styles.bensContainer}>
          {bens?.map((bem) => (
            <BemCard
              nome={bem.nome}
              valor={bem.valor}
              imagem={bem.imagem}
              key={bem.nome}
              active={selectedBem?.nome === bem.nome}
              onClick={() => handleActiveCard(bem)}
            />
          ))}
        </ul>
        <div className={styles.buttons}>
          <Button outline onClick={onBack}>
            <FiArrowLeft style={{strokeWidth: 3}}/>
            Voltar    
          </Button>
          <Button onClick={handleSubmit} disabled={selectedBem === null}>
            Continuar
            <FiArrowRight style={{strokeWidth: 3}}/>
          </Button>
        </div>
    </Box>
  )
}
export default Bens
